/* SESE YOLO Bundle Builder v1.8 (optional text-only savings badges + v1.5 fast cart)
   Theme Editor offers/add-ons; independent variant choices; Shopify Ajax cart + discount.
   Note: discounts are cart-wide and might conflict with other existing discounts.
*/
(() => {
  if (window.__SESEBundleBuilderInit) return;
  window.__SESEBundleBuilderInit = true;

  const q = (el, selector) => el.querySelector(selector);
  const qa = (el, selector) => Array.from(el.querySelectorAll(selector));

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function money(root, cents) {
    const code = root.dataset.currency || 'USD';
    const loc = root.dataset.locale && root.dataset.locale.startsWith('es') ? 'es-ES' : 'en-US';
    try {
      return new Intl.NumberFormat(loc, { style: 'currency', currency: code }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }
  function lang(root, en, es) {
    return root.dataset.locale && root.dataset.locale.startsWith('es') ? es : en;
  }
  function discountCents(offer) {
    const amount = String(offer.dataset.discount || '').replace(/\s/g, '').replace(',', '.');
    return Math.max(0, Math.round((Number.parseFloat(amount) || 0) * 100));
  }
  function chosenVariants(root, offer) {
    const ids = qa(offer, '[data-sese-variant-select]').map(s => Number(s.value));
    const byId = root._seseVariantById;
    return ids.map(id => byId.get(id)).filter(Boolean);
  }
  function calculate(root, offer) {
    const variants = chosenVariants(root, offer);
    if (!variants.length) return;
    const base = variants.reduce((sum, variant) => sum + Number(variant.price || 0), 0);
    const compare = variants.reduce((sum, variant) => {
      const price = Number(variant.price || 0);
      return sum + Math.max(price, Number(variant.compare_at_price || 0));
    }, 0);
    const off = discountCents(offer);
    q(offer, '[data-sese-total]').textContent = money(root, Math.max(0, base - off));
    const compareNode = q(offer, '[data-sese-compare]');
    if (compare > base - off) {
      compareNode.textContent = money(root, compare);
      compareNode.hidden = false;
    } else {
      compareNode.hidden = true;
    }
    const saving = q(offer, '[data-sese-saving]');
    // Savings badge is strictly opt-in text. Empty wording => no badge.
    // Display never derives badge text from fixed discount amount.
    // Real Shopify discounts and estimated totals remain unchanged.
    const manualEn = (offer.dataset.savingEn || '').trim();
    const manualEs = (offer.dataset.savingEs || '').trim();
    const badgeText = lang(root, manualEn, manualEs || manualEn);
    const showBadge = offer.dataset.showSaving !== 'false';
    if (showBadge && badgeText) {
      saving.textContent = badgeText; // textContent: safe plain text, no HTML.
      saving.hidden = false;
    } else {
      saving.textContent = '';
      saving.hidden = true;
    }
  }
  function addonRow(root, source) {
    if (source.dataset.addonAvailable !== 'true') return null;
    const row = document.createElement('label');
    row.className = 'sese-bb__addon-row';
    row.dataset.seseAddonId = source.dataset.addonId;
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'sese-bb__addon-check';
    checkbox.dataset.seseAddonCheck = '';
    checkbox.checked = source.dataset.addonDefault === 'true';
    checkbox.setAttribute('aria-label', lang(root, source.dataset.addonEn, source.dataset.addonEs));
    row.append(checkbox);
    if (source.dataset.addonImage) {
      const img = document.createElement('img');
      img.src = source.dataset.addonImage;
      img.alt = '';
      img.loading = 'lazy';
      img.className = 'sese-bb__addon-image';
      row.append(img);
    }
    const label = document.createElement('span');
    label.className = 'sese-bb__addon-name';
    label.textContent = '+ ' + lang(root, source.dataset.addonEn, source.dataset.addonEs);
    row.append(label);
    const prices = document.createElement('span');
    prices.className = 'sese-bb__addon-price';
    const price = document.createElement('strong');
    price.textContent = money(root, Number(source.dataset.addonPrice));
    prices.append(price);
    const compare = Number(source.dataset.addonCompare);
    if (compare > Number(source.dataset.addonPrice)) {
      const del = document.createElement('del');
      del.textContent = money(root, compare);
      prices.append(del);
    }
    row.append(prices);
    return row;
  }
  function showOffer(root, target) {
    qa(root, '[data-sese-offer]').forEach(offer => {
      const selected = offer === target;
      offer.classList.toggle('is-selected', selected);
      q(offer, '[data-sese-select]').setAttribute('aria-pressed', selected ? 'true' : 'false');
      q(offer, '[data-sese-body]').hidden = !selected;
    });
    const msg = q(root, '[data-sese-message]');
    msg.hidden = true;
    // Changing tiers must never switch ADD TO CART into an old "retry" operation.
    // All selections use a new cart/add.js request on every intentional click.
    const button = q(root, '[data-sese-cart]');
    if (root._seseOriginalButtonHtml && !button.disabled) {
      button.innerHTML = root._seseOriginalButtonHtml;
    }
  }
  function setupVariantRows(root, offer, variants) {
    const quantity = Math.max(1, Math.min(12, Number(offer.dataset.quantity) || 1));
    const list = q(offer, '[data-sese-unit-variants]');
    list.replaceChildren();
    const available = variants.filter(v => v.available);
    if (!available.length) return;
    const hasChoices = variants.length > 1;
    if (!hasChoices) {
      const input = document.createElement('select');
      input.hidden = true;
      input.dataset.seseVariantSelect = '';
      input.value = String(available[0].id);
      const option = document.createElement('option');
      option.value = String(available[0].id);
      option.textContent = available[0].title;
      input.append(option);
      for (let i = 0; i < quantity; i++) list.append(input.cloneNode(true));
      return;
    }
    const optionLabel = root.dataset.optionLabel || 'Color';
    for (let i = 0; i < quantity; i++) {
      const row = document.createElement('div');
      row.className = 'sese-bb__variant-item';
      const img = document.createElement('img');
      img.className = 'sese-bb__variant-thumb';
      img.alt = '';
      img.loading = 'lazy';
      const field = document.createElement('div');
      field.className = 'sese-bb__variant-field';
      const label = document.createElement('span');
      label.className = 'sese-bb__variant-label';
      label.textContent = lang(root, optionLabel, optionLabel.toLowerCase().includes('color') || optionLabel.toLowerCase().includes('colour') ? 'Color' : 'Opción') + (quantity > 1 ? ' ' + (i + 1) : '');
      const select = document.createElement('select');
      select.className = 'sese-bb__variant-select';
      select.dataset.seseVariantSelect = '';
      select.setAttribute('aria-label', label.textContent);
      variants.forEach(variant => {
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = (variant.public_title || variant.title || 'Default');
        option.disabled = !variant.available;
        if (variant.id === available[0].id) option.selected = true;
        select.append(option);
      });
      function syncImage() {
        const active = root._seseVariantById.get(Number(select.value));
        const src = active && active.featured_image && active.featured_image.src;
        if (src) { img.src = src; img.hidden = false; }
        else { img.removeAttribute('src'); img.hidden = true; }
        calculate(root, offer);
      }
      select.addEventListener('change', syncImage);
      field.append(label, select);
      row.append(img, field);
      list.append(row);
      syncImage();
    }
  }
  function init(root) {
    if (root.dataset.seseInitialized === 'true') return;
    root.dataset.seseInitialized = 'true';
    let variants;
    try { variants = JSON.parse(q(root, '[data-sese-variants]').textContent); }
    catch (_) { return; }
    root._seseVariantById = new Map(variants.map(v => [Number(v.id), v]));
    const offers = qa(root, '[data-sese-offer]');
    const addons = qa(root, '[data-sese-addon-source]').slice(0, 4);
    if (!offers.length) {
      q(root, '[data-sese-cart]').hidden = true;
      return;
    }
    const usable = variants.some(v => v.available);
    if (!usable) q(root, '[data-sese-cart]').disabled = true;
    for (const offer of offers) {
      setupVariantRows(root, offer, variants);
      const wrap = q(offer, '[data-sese-addon-list]');
      for (const source of addons) {
        const row = addonRow(root, source);
        if (row) wrap.append(row);
      }
      calculate(root, offer);
      q(offer, '[data-sese-select]').addEventListener('click', () => showOffer(root, offer));
    }
    showOffer(root, offers.find(o => o.dataset.default === 'true') || offers[0]);
    q(root, '[data-sese-cart]').addEventListener('click', () => addToCart(root));
  }
  function issue(root, message) {
    const node = q(root, '[data-sese-message]');
    node.textContent = message;
    node.hidden = false;
  }
  async function ajax(endpoint, payload) {
    const response = await fetch(shopRoot() + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    const json = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(json.description || json.message || 'Cart request failed');
    return json;
  }
  // Prefer Shrine Pro's native cart section IDs. A small cart section is
  // much faster than downloading the full product page to redraw the drawer.
  // Fallback keeps the working v1.4 full-page refresh when sections fail.
  function cartSectionConfig() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return null;
    try {
      const definitions = drawer.getSectionsToRender();
      if (!Array.isArray(definitions)) return null;
      const ids = [...new Set(definitions.map(def => String(def && def.id || '').trim()).filter(Boolean))].slice(0, 5);
      if (!ids.length) return null;
      return { ids, url: window.location.pathname + window.location.search };
    } catch (error) {
      console.warn('SESE: Could not detect cart sections; using safe fallback.', error);
      return null;
    }
  }
  function renderCartSectionsAndOpen(sections) {
    if (!sections || typeof sections !== 'object') return false;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    const parser = new DOMParser();
    let freshDrawer = null;
    let freshBubble = null;
    for (const html of Object.values(sections)) {
      if (typeof html !== 'string' || !html) continue;
      const part = parser.parseFromString(html, 'text/html');
      if (!freshDrawer) freshDrawer = part.querySelector('cart-drawer');
      if (!freshBubble) freshBubble = part.getElementById('cart-icon-bubble');
    }
    if (!freshDrawer ||
        freshDrawer.classList.contains('is-empty') ||
        freshDrawer.querySelector('.drawer__inner')?.classList.contains('is-empty')) {
      return false;
    }

    // The verified v1.4 technique: replace the entire native custom element.
    // Never inject a new cart item manually or use stale cart HTML.
    const replacement = document.importNode(freshDrawer, true);
    replacement.classList.remove('is-empty');
    replacement.querySelector('.drawer__inner')?.classList.remove('is-empty');
    if (typeof replacement.open !== 'function') return false;
    drawer.replaceWith(replacement);
    if (freshBubble) {
      const currentBubble = document.getElementById('cart-icon-bubble');
      if (currentBubble) currentBubble.innerHTML = freshBubble.innerHTML;
    }
    replacement.open();
    return true;
  }
  async function loadCartSections(config) {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', config.ids.join(','));
    const response = await fetch(url.toString(), {
      method: 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    });
    if (!response.ok) throw new Error('Cart section request failed (HTTP ' + response.status + ').');
    return response.json();
  }
  // Working v1.4 fallback: download and parse the full product-page HTML.
  async function refreshAndOpenDrawer() {
    const oldDrawer = document.querySelector('cart-drawer');
    if (!oldDrawer) {
      throw new Error('Shrine Pro cart-drawer element not found.');
    }

    // Always use the same URL, including preview_theme_id when editing a draft.
    const url = new URL(window.location.href);
    url.searchParams.set('_sese_drawer_reload', Date.now().toString());
    const response = await fetch(url.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'text/html' }
    });
    if (!response.ok) {
      throw new Error('Could not load updated drawer HTML (HTTP ' + response.status + ').');
    }
    const html = await response.text();
    const parsedPage = new DOMParser().parseFromString(html, 'text/html');
    const freshDrawer = parsedPage.querySelector('cart-drawer');
    if (!freshDrawer) {
      throw new Error('Updated page did not contain a cart drawer.');
    }
    // Never replace a cart with an empty drawer right after a successful add.
    if (freshDrawer.classList.contains('is-empty') ||
        freshDrawer.querySelector('.drawer__inner')?.classList.contains('is-empty')) {
      throw new Error('New drawer HTML was unexpectedly empty.');
    }

    const replacement = document.importNode(freshDrawer, true);
    replacement.classList.remove('is-empty');
    replacement.querySelector('.drawer__inner')?.classList.remove('is-empty');
    oldDrawer.replaceWith(replacement);

    const liveBubble = document.getElementById('cart-icon-bubble');
    const freshBubble = parsedPage.getElementById('cart-icon-bubble');
    if (liveBubble && freshBubble) {
      liveBubble.innerHTML = freshBubble.innerHTML;
    }

    if (typeof replacement.open === 'function') replacement.open();
    else throw new Error('Updated cart drawer does not expose its open() method.');
  }

  async function addToCart(root) {
    const offer = q(root, '[data-sese-offer].is-selected');
    if (!offer || root._seseBusy) return;

    // IMPORTANT: Never skip an add because previous items already exist or a
    // previous drawer/discount refresh failed. Always build a new request.
    const variants = chosenVariants(root, offer);
    const quantity = Number(offer.dataset.quantity);
    if (!Number.isInteger(quantity) || variants.length !== quantity || variants.some(v => !v.available)) {
      issue(root, lang(root,
        'Please choose available product options.',
        'Elige opciones de producto disponibles.'));
      return;
    }
    const counts = new Map();
    variants.forEach(v => counts.set(Number(v.id), (counts.get(Number(v.id)) || 0) + 1));
    qa(offer, '[data-sese-addon-check]:checked').forEach(check => {
      const row = check.closest('[data-sese-addon-id]');
      if (!row) return;
      const id = Number(row.dataset.seseAddonId);
      if (id) counts.set(id, (counts.get(id) || 0) + 1);
    });
    const items = Array.from(counts.entries()).map(([id, quantity]) => ({ id, quantity }));
    const code = (offer.dataset.code || '').trim();

    const button = q(root, '[data-sese-cart]');
    if (!root._seseOriginalButtonHtml) root._seseOriginalButtonHtml = button.innerHTML;
    root._seseBusy = true;
    button.disabled = true;
    button.textContent = lang(root, 'ADDING…', 'AÑADIENDO…');
    q(root, '[data-sese-message]').hidden = true;
    let confirmedAdded = false;
    let discountWarning = '';

    try {
      // Only one add operation per click. Existing cart lines are preserved.
      // Do not include sections in this POST: a section-rendering HTTP 400 can
      // still add items, making client retries duplicate the purchase.
      await ajax('cart/add.js', { items });
      confirmedAdded = true;

      const config = cartSectionConfig();
      let sections = null;
      if (code) {
        try {
          // Shopify renders current cart sections with the same update request
          // that applies the discount. This saves a round trip and a full-page GET.
          const payload = { discount: code };
          if (config) {
            payload.sections = config.ids;
            payload.sections_url = config.url;
          }
          const update = await ajax('cart/update.js', payload);
          sections = update.sections || null;
        } catch (error) {
          discountWarning = String(error.message || error);
          console.warn('SESE: Products added, but discount update failed:', error);
        }
      } else if (config) {
        // Buy 1 has no discount update: fetch just the small cart sections.
        try { sections = await loadCartSections(config); }
        catch (error) { console.warn('SESE: Fast cart sections unavailable.', error); }
      }

      try {
        let updated = false;
        if (sections) {
          try { updated = renderCartSectionsAndOpen(sections); }
          catch (error) { console.warn('SESE: Fast cart render failed; retrying with proven drawer refresh.', error); }
        }
        if (!updated) await refreshAndOpenDrawer();
        if (discountWarning) {
          issue(root, lang(root,
            'Products were added, but the discount could not be confirmed. Please check the discount in your cart.',
            'Los productos se añadieron, pero no se pudo confirmar el descuento. Comprueba el descuento en el carrito.'));
        }
      } catch (error) {
        console.error('SESE: Products added, but drawer refresh/open failed:', error);
        issue(root, lang(root,
          'Products were added to your cart, but the drawer could not refresh. Open the cart icon to check the new items. Do not click Add to Cart again unless you want more items.',
          'Los productos se añadieron, pero no se pudo actualizar el carrito. Abre el icono del carrito para comprobarlos. No pulses Añadir al carrito otra vez a menos que quieras más unidades.'));
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          try { drawer.open(); } catch (_) { /* already reported */ }
        }
      }
    } catch (error) {
      console.error('SESE Bundle Builder:', error);
      issue(root, confirmedAdded
        ? lang(root,
          'Add request succeeded, but the cart could not be verified. Please inspect your cart before trying again.',
          'La solicitud se completó, pero no se pudo verificar el carrito. Comprueba el carrito antes de volver a intentarlo.')
        : String(error.message || error));
    } finally {
      button.innerHTML = root._seseOriginalButtonHtml;
      button.disabled = false;
      root._seseBusy = false;
    }
  }
  function initAll() {
    document.querySelectorAll('[data-sese-bundle-builder]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', event => {
    const offer = event.target.closest && event.target.closest('[data-sese-offer]');
    if (!offer) return;
    const root = offer.closest('[data-sese-bundle-builder]');
    if (root) showOffer(root, offer);
  });
})();
